import { exportAudience } from '@/features/AudienceManager/services';
export const saveExportAudience = (audienceId, columns) => {
    return exportAudience(audienceId, columns).then(response => formatValue(response?.data));
};
const formatValue = (response) => {
    return {
        batchId: response.data.batchId,
        success: response?.success,
    };
};
